import React, { useEffect, useState } from "react";
import "./PartnerStatusDetails.scss";

import { useDispatch, useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import { MdInfoOutline } from "react-icons/md";

import { getPartnerShipmentStatusOrders } from "../../store/statusUpdates/partnerShipmentStatus/partnerShipmentStatusSlice";
import PartnerStatusTitleContainer from "../PartnerStatusTitleContainer/PartnerStatusTitleContainer";
import SubscribeRouteComponent from "../../componentsSubscribers/SubscribersDetails/SubscribeRouteComponent/SubscribeRouteComponent";
import SubscribeCargoComponent from "../../componentsSubscribers/SubscribersDetails/SubscribeCargoComponent/SubscribeCargoComponent";
import PartnerStatusUpdateCard from "../PartnerStatusUpdateCard/PartnerStatusUpdateCard";
import LoadingPage from "../../componentsAdditional/Loading/LoadingPage/LoadingPage";
import PartnerStatusUpdatedCard from "../PartnerStatusUpdatedCard/PartnerStatusUpdatedCard";

const PartnerStatusDetails = () => {
  const dispatch = useDispatch();
  const { signature } = useParams();
  const [searchParams] = useSearchParams();

  const { getPartnerShipmentStatusOrdersResult, getPartnerShipmentStatusOrdersLoading } =
    useSelector((state) => state.partnerShipmentStatus);

  const [activeOrder, setActiveOrder] = useState(null);

  useEffect(() => {
    if (getPartnerShipmentStatusOrdersResult && getPartnerShipmentStatusOrdersResult.length > 0) {
      const activeNewOrder = getPartnerShipmentStatusOrdersResult.find(
        (order) => order.id?.toString() === searchParams.get("orderId")
      );

      if (activeNewOrder) {
        setActiveOrder(activeNewOrder);
      } else {
        setActiveOrder(getPartnerShipmentStatusOrdersResult[0]);
      }
    }
  }, [getPartnerShipmentStatusOrdersResult, searchParams]);

  useEffect(() => {
    dispatch(getPartnerShipmentStatusOrders(signature));
  }, [signature, dispatch]);

  return (
    <div id='PartnerStatusDetails'>
      {getPartnerShipmentStatusOrdersLoading && <LoadingPage />}
      {getPartnerShipmentStatusOrdersResult && (
        <>
          <PartnerStatusTitleContainer
            data={getPartnerShipmentStatusOrdersResult}
            setActiveOrder={setActiveOrder}
          />
          <div className='infoMessageContainer'>
            <div className='icon'>
              <MdInfoOutline />
            </div>
            <div className='text'>
              This link allows you to update the shipment status in real time. If you're not the one
              handling this shipment directly, you can share this link with the driver responsible
              for updates.
            </div>
          </div>
          <div className='cardsContainer'>
            <div className='leftSideContainer'>
              <SubscribeRouteComponent order={activeOrder} />
              {/* <SubscribeCargoComponent order={activeOrder} /> */}
            </div>
            {false ? (
              <PartnerStatusUpdatedCard order={activeOrder} />
            ) : (
              <PartnerStatusUpdateCard order={activeOrder} />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default PartnerStatusDetails;
